(function () {
  "use strict";

  /* ── Formatear RUT ── */
  function formatRut(value) {
    var clean = value.replace(/[^0-9kK]/g, "").toUpperCase();
    if (clean.length === 0) return "";
    var body = clean.slice(0, -1);
    var dv = clean.slice(-1);
    if (body.length === 0) return dv;
    var formatted = "";
    for (var i = body.length - 1, c = 0; i >= 0; i--, c++) {
      if (c > 0 && c % 3 === 0) formatted = "." + formatted;
      formatted = body[i] + formatted;
    }
    return formatted + "-" + dv;
  }

  /* ── Validar RUT módulo 11 ── */
  function validateRut(value) {
    var clean = value.replace(/\./g, "").replace(/-/g, "").trim().toUpperCase();
    if (clean.length < 2) return false;
    var body = clean.slice(0, -1);
    var dv = clean.slice(-1);
    if (!/^\d+$/.test(body)) return false;
    var sum = 0,
      mul = 2;
    for (var i = body.length - 1; i >= 0; i--) {
      sum += parseInt(body[i], 10) * mul;
      mul = mul === 7 ? 2 : mul + 1;
    }
    var rem = sum % 11;
    var calc = 11 - rem;
    var expected = calc === 11 ? "0" : calc === 10 ? "K" : String(calc);
    return dv === expected;
  }

  /* ══════════════════════════════════════════════════════
     COMPRA MÍNIMA
     El monto se define en el snippet (data-min, en centavos).
     ══════════════════════════════════════════════════════ */

  var MIN_FALLBACK = 2000000; /* $20.000 en centavos */
  var cartTotalCents = null; /* null = usar el valor renderizado por Liquid */

  function getMinCents() {
    var el = document.querySelector(".js-doc-min");
    var v = el ? parseInt(el.getAttribute("data-min"), 10) : NaN;
    return isNaN(v) ? MIN_FALLBACK : v;
  }

  function getCartTotalCents() {
    if (cartTotalCents !== null) return cartTotalCents;
    var el = document.querySelector(".js-doc-min");
    var v = el ? parseInt(el.getAttribute("data-total"), 10) : NaN;
    return isNaN(v) ? 0 : v;
  }

  function formatCLP(cents) {
    return "$" + Math.round(cents / 100).toLocaleString("es-CL");
  }

  /* Refrescar el total real del carrito (el drawer no siempre re-renderiza) */
  function refreshCartTotal() {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "/cart.js", true);
    xhr.onload = function () {
      try {
        var data = JSON.parse(xhr.responseText);
        if (typeof data.total_price === "number") {
          cartTotalCents = data.total_price;
          validateState();
        }
      } catch (err) {
        /* ignorar: se mantiene el valor de Liquid */
      }
    };
    xhr.send();
  }

  /* ── Guardar cart attributes ── */
  var saveTimer = null;
  function saveAttributes(tipo, rut, giro) {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      var attrs = { "Tipo de documento": tipo };
      attrs["RUT"] = rut || "";
      attrs["Giro"] = tipo === "Factura" && giro ? giro : "";
      var xhr = new XMLHttpRequest();
      xhr.open("POST", "/cart/update.js", true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(JSON.stringify({ attributes: attrs }));
    }, 500);
  }

  /* ── Bloquear/desbloquear checkout ── */
  function setCheckoutBlocked(blocked) {
    [
      'button[name="checkout"]',
      'input[name="checkout"]',
      '[name="checkout"]',
      ".cart__checkout-button",
      ".shopify-payment-button button",
      ".hdt-main-cart__button-checkout",
      ".hdt-mini-cart__btn-checkout",
      '.cart__ctas button[type="submit"]',
      "[data-shopify-pay] button",
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (blocked) {
          el.setAttribute("disabled", "disabled");
          el.style.opacity = "0.5";
          el.style.pointerEvents = "none";
        } else {
          el.removeAttribute("disabled");
          el.style.opacity = "";
          el.style.pointerEvents = "";
        }
      });
    });
  }

  /* ── Leer estado actual (primera instancia) ── */
  function getState() {
    var tipoEl = document.querySelector(".js-doc-tipo");
    var rutEl = document.querySelector(".js-doc-rut");
    var giroEl = document.querySelector(".js-doc-giro");
    return {
      tipo: tipoEl ? tipoEl.value : "",
      rut: rutEl ? rutEl.value : "",
      giro: giroEl ? giroEl.value : "",
    };
  }

  /* ── Sincronizar visibilidad/valores en TODAS las instancias ── */
  function syncAll(tipo, rutVal) {
    var hasType = tipo === "Boleta" || tipo === "Factura";

    document.querySelectorAll(".js-doc-tipo").forEach(function (s) {
      s.value = tipo;
    });
    document.querySelectorAll(".js-doc-rut-wrap").forEach(function (w) {
      w.style.display = hasType ? "block" : "none";
    });
    document.querySelectorAll(".js-doc-giro-wrap").forEach(function (w) {
      w.style.display = tipo === "Factura" ? "block" : "none";
    });
    document.querySelectorAll(".js-doc-rut-label").forEach(function (l) {
      l.textContent = tipo === "Factura" ? "RUT empresa" : "RUT";
    });

    if (!hasType) {
      /* sin tipo: limpiar todo */
      document.querySelectorAll(".js-doc-rut").forEach(function (inp) {
        inp.value = "";
        inp.classList.remove("doc-tributario__input--invalid", "doc-tributario__input--valid");
      });
      document.querySelectorAll(".js-doc-giro").forEach(function (inp) {
        inp.value = "";
        inp.classList.remove("doc-tributario__input--invalid", "doc-tributario__input--valid");
      });
      document.querySelectorAll(".js-doc-rut-error, .js-doc-rut-ok").forEach(function (e) {
        e.style.display = "none";
      });
    } else {
      /* el RUT se conserva entre Boleta/Factura; el Giro solo aplica a Factura */
      if (tipo !== "Factura") {
        document.querySelectorAll(".js-doc-giro").forEach(function (inp) {
          inp.value = "";
          inp.classList.remove("doc-tributario__input--invalid", "doc-tributario__input--valid");
        });
      }
      if (rutVal !== undefined) {
        document.querySelectorAll(".js-doc-rut").forEach(function (inp) {
          inp.value = rutVal;
        });
      }
    }
  }

  /* ── Validar estado completo + actualizar visual + guardar/bloquear ── */
  function validateState() {
    var st = getState();
    var hasType = st.tipo === "Boleta" || st.tipo === "Factura";
    var rutEmpty = !st.rut || st.rut.trim().length === 0;
    var rutValid = !rutEmpty && validateRut(st.rut);
    var giroEmpty = !st.giro || st.giro.trim().length === 0;
    var giroOk = st.tipo !== "Factura" || !giroEmpty;

    /* Visual RUT */
    document.querySelectorAll(".js-doc-rut").forEach(function (inp) {
      inp.classList.toggle("doc-tributario__input--invalid", hasType && !rutEmpty && !rutValid);
      inp.classList.toggle("doc-tributario__input--valid", hasType && rutValid);
    });
    document.querySelectorAll(".js-doc-rut-error").forEach(function (e) {
      e.style.display = hasType && !rutEmpty && !rutValid ? "block" : "none";
    });
    document.querySelectorAll(".js-doc-rut-ok").forEach(function (e) {
      e.style.display = hasType && rutValid ? "block" : "none";
    });

    /* Visual Giro (solo Factura) */
    if (st.tipo === "Factura") {
      document.querySelectorAll(".js-doc-giro").forEach(function (inp) {
        inp.classList.toggle("doc-tributario__input--invalid", giroEmpty);
        inp.classList.toggle("doc-tributario__input--valid", !giroEmpty);
      });
    }

    /* Compra mínima */
    var total = getCartTotalCents();
    var minOk = total >= getMinCents();
    document.querySelectorAll(".js-doc-min").forEach(function (b) {
      b.style.display = minOk ? "none" : "block";
    });
    document.querySelectorAll(".js-doc-min-total").forEach(function (t) {
      t.textContent = formatCLP(total);
    });

    var docOk = hasType && rutValid && giroOk;
    var allOk = docOk && minOk;
    setCheckoutBlocked(!allOk);

    /* Los datos tributarios se guardan aunque falte alcanzar el mínimo */
    if (docOk) {
      var clean = st.rut.replace(/\./g, "").replace(/-/g, "").trim().toUpperCase();
      saveAttributes(st.tipo, formatRut(clean), st.giro.trim());
    }
    return allOk;
  }

  /* ══════════════════════════════════════════════════════
     DELEGACIÓN DE EVENTOS EN DOCUMENT
     ══════════════════════════════════════════════════════ */

  var rutDebounce = null;

  /* Cambio de tipo de documento */
  document.addEventListener("change", function (e) {
    if (!e.target.classList.contains("js-doc-tipo")) return;
    syncAll(e.target.value);
    validateState();
  });

  /* Input de RUT y Giro */
  document.addEventListener("input", function (e) {
    /* Giro */
    if (e.target.classList.contains("js-doc-giro")) {
      var giroVal = e.target.value;
      document.querySelectorAll(".js-doc-giro").forEach(function (other) {
        if (other !== e.target) other.value = giroVal;
      });
      validateState();
      return;
    }

    /* RUT */
    if (!e.target.classList.contains("js-doc-rut")) return;
    var inp = e.target;

    /* Formatear conservando posición del cursor */
    var pos = inp.selectionStart;
    var before = inp.value.length;
    inp.value = formatRut(inp.value);
    var after = inp.value.length;
    inp.setSelectionRange(
      Math.max(0, pos + (after - before)),
      Math.max(0, pos + (after - before)),
    );

    /* Sincronizar a otras instancias */
    var val = inp.value;
    document.querySelectorAll(".js-doc-rut").forEach(function (other) {
      if (other !== inp) other.value = val;
    });

    /* Debounce validación */
    clearTimeout(rutDebounce);
    rutDebounce = setTimeout(validateState, 400);
  });

  /* ── Estado inicial (también re-aplicado cuando el drawer se re-renderiza) ── */
  function checkInitial() {
    var first = document.querySelector(".js-doc-tipo");
    if (!first) return;
    syncAll(first.value);
    validateState();
    refreshCartTotal();
  }

  /* El carrito cambió (agregar/quitar/cantidad): revalidar el mínimo */
  ["cart:updated", "cart:refresh", "cart:change", "on:cart:updated"].forEach(function (evt) {
    document.addEventListener(evt, function () {
      refreshCartTotal();
    });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkInitial);
  } else {
    checkInitial();
  }

  /* Re-inicializar cuando el cart drawer/carrito inyecta nuevas instancias */
  var initDebounce = null;
  function hasDocNode(node) {
    if (node.nodeType !== 1) return false;
    return (
      (node.matches && node.matches(".js-doc-tipo")) ||
      (node.querySelector && node.querySelector(".js-doc-tipo"))
    );
  }
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (hasDocNode(added[j])) {
          clearTimeout(initDebounce);
          initDebounce = setTimeout(checkInitial, 60);
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
